import { render, staticRenderFns } from "./NameOrderOnlinePickUp.vue?vue&type=template&id=a2c13728&scoped=true"
import script from "./NameOrderOnlinePickUp.vue?vue&type=script&lang=js"
export * from "./NameOrderOnlinePickUp.vue?vue&type=script&lang=js"
import style0 from "./NameOrderOnlinePickUp.vue?vue&type=style&index=0&id=a2c13728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c13728",
  null
  
)

export default component.exports